import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

function CustomDialog({
  open,
  title,
  content,
  onClose,
  onSecondaryClick,
  onPrimaryClick,
  primaryText = "Confirm",
  secondaryText = "Cancel",
  disablePrimary = null,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onSecondaryClick} color="secondary">
          {secondaryText}
        </Button>
        <Button
          color="primary"
          onClick={onPrimaryClick}
          disabled={disablePrimary}
        >
          {primaryText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomDialog;
